import { SizableText, SmartLink, TextLink, XStack, YStack } from '@my/ui'
import { formatTimeToNow } from 'app/utils/format-time-to-now'
import { GroupAvatar } from '../group-avatar'
import { PostUserProps } from './post-user-props'
import { useState } from 'react'
import { UserPopup } from '../../containers'

const interactionStyles = {
  hoverStyle: {
    opacity: 0.8,
  },
  focusStyle: {
    opacity: 0.8,
  },
  pressStyle: {
    opacity: 0.75,
  },
}

export const GroupUser = ({ creator, group, createdAt, editedAt, ...props }: PostUserProps) => {
  const [userOpen, setUserOpen] = useState(false)

  if (!createdAt || !group) {
    return null
  }

  const formattedTime = formatTimeToNow(createdAt)
  return (
    <XStack flexShrink={1} gap="$2" {...props}>
      <SmartLink
        Component={GroupAvatar}
        href={`/groups/${group.id}`}
        tabIndex={-1}
        flexShrink={0}
        width={44}
        height={44}
        src={group.profileImage.small}
        rounded={false}
        {...interactionStyles}
      />

      <YStack flexShrink={1}>
        <TextLink
          href={`/groups/${group.id}`}
          numberOfLines={1}
          size="$4"
          fow="600"
          $gtSm={{ size: '$5', fow: '600' }}
          textDecorationLine="none"
          {...interactionStyles}
        >
          {group.name}
        </TextLink>
        <XStack flexShrink={1} flexWrap="wrap" rowGap="$1" columnGap="$2" ai="center">
          {creator && (
            <SizableText
              tag="button"
              cursor="pointer"
              aria-label="Open user popup"
              onPress={() => setUserOpen(true)}
              numberOfLines={1}
              color="$offBlack"
              size="$1"
              focusStyle={{
                textDecorationLine: 'underline',
              }}
              pressStyle={{
                textDecorationLine: 'underline',
              }}
              hoverStyle={{
                textDecorationLine: 'underline',
              }}
            >
              {creator.fullName}
            </SizableText>
          )}
          <SizableText color="$gray11" size="$1">
            {formattedTime} {editedAt && '· Edited'}
          </SizableText>
        </XStack>
      </YStack>

      {userOpen && <UserPopup user={creator} open={userOpen} onOpenChange={setUserOpen} />}
    </XStack>
  )
}
